import * as FiIcons from 'react-icons/fi';
import ChromaGrid from './ChromaGrid';
import {incrementClicks} from '../services/siteContentService';

const {FiArrowUpRight, FiCoffee, FiLayers, FiMusic, FiPackage, FiShoppingBag, FiZap} = FiIcons;

const icons = {
  deals: FiZap,
  music: FiMusic,
  portfolio: FiLayers,
  amazon: FiPackage,
  merch: FiShoppingBag,
  support: FiCoffee
};

const themes = {
  deals: {
    borderColor: '#fbbf24',
    gradient: 'linear-gradient(110deg,rgba(251,191,36,0.15),#171b24 48%)'
  },
  amazon: {
    borderColor: '#ff9900',
    gradient: 'linear-gradient(110deg,rgba(255,153,0,0.15),#171b24 48%)'
  },
  music: {
    borderColor: '#c084fc',
    gradient: 'linear-gradient(110deg,rgba(192,132,252,0.15),#171b24 48%)'
  },
  portfolio: {
    borderColor: '#38bdf8',
    gradient: 'linear-gradient(110deg,rgba(56,189,248,0.15),#171b24 48%)'
  },
  merch: {
    borderColor: '#64e8ce',
    gradient: 'linear-gradient(110deg,rgba(100,232,206,0.15),#171b24 48%)'
  },
  support: {
    borderColor: '#ffdd00',
    gradient: 'linear-gradient(110deg,rgba(255,221,0,0.15),#171b24 48%)'
  }
};

export default function HomeActionGrid({actions}) {
  const items = actions.map((action) => ({
    ...action,
    key: action.kind,
    subtitle: action.description,
    icon: icons[action.kind] || FiZap,
    arrowIcon: FiArrowUpRight,
    external: !action.url.startsWith('#'),
    badge:
      action.kind === 'support'
        ? 'https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png'
        : undefined,
    ...(themes[action.kind] || themes.merch)
  }));

  const trackClick = (action) => {
    if (!action.persisted || !action.id) return;
    incrementClicks('links', action).catch(() => {});
  };

  return (
    <section className="home-action-section" aria-labelledby="explore-heading">
      <div className="action-section-heading">
        <span>Curated by Dadda Cool</span>
        <h2 id="explore-heading">Explore the universe</h2>
      </div>
      <ChromaGrid
        items={items}
        radius={220}
        damping={0.4}
        fadeOut={0.5}
        ease="power3.out"
        onItemClick={trackClick}
      />
    </section>
  );
}